import React from "react";
import Currency from "./Currency";
import {ProgressBar} from "react-bootstrap";
import _ from "underscore";

const RebagRewardsProgressBar = ({user_profile, rewards_tiers, custom_class}) => {
    const max_tier_value = rewards_tiers[Object.keys(rewards_tiers)[Object.keys(rewards_tiers).length - 1]].tier_value;
    const first_tier_value = rewards_tiers.tier_1.tier_value;
    const current_value_spent = user_profile.tier.l12m_value;
    const current_tier_key = user_profile.tier.tier_key;
    const next_tier_key = user_profile.tier.next_tier_key;

    return (
        <div className={`rr-summary__progress ${custom_class ? custom_class : ""}`}>
            {_.map(rewards_tiers, (rewards_tier) => {
                let current_segment_percentage = current_value_spent < rewards_tier.tier_value ? 0 : 100;
                if (rewards_tier.key === current_tier_key && next_tier_key) {
                    current_segment_percentage = (current_value_spent - rewards_tiers[current_tier_key].tier_value) / (rewards_tiers[next_tier_key || current_tier_key].tier_value - rewards_tiers[current_tier_key].tier_value) * 100;
                }

                return (
                    <div
                        key={rewards_tier.key}
                        className={`rr-summary__segment-container rr-summary__segment-container--${rewards_tier.key} ${rewards_tier.key === current_tier_key && next_tier_key ? "rr-summary__segment-container--in-progress" : ""}`}
                    >
                        {rewards_tier.key === current_tier_key &&
                        <div className={`rr-summary__segment-tooltip ${current_value_spent >= max_tier_value ? "rr-summary__segment-tooltip--congrats" : ""} ${current_value_spent < first_tier_value ? "rr-summary__segment-tooltip--no-tier" : "" }`} style={{left: `${current_value_spent < max_tier_value ? current_segment_percentage : 0}%`}}>
                            {current_value_spent >= max_tier_value ? <><span className="icon-balloons rr-summary__congrats-icon"/><span>Congratulations! You've reached <strong>Diamond</strong></span></> : "You're here"}
                        </div>
                        }
                        <ProgressBar className="rr-summary__segment" now={current_segment_percentage}/>
                        {rewards_tier.key === current_tier_key && current_value_spent < max_tier_value &&
                        <div className="rr-summary__segment-under-tooltip acc-rebag-rewards__text" style={{left: `${current_segment_percentage}%`}}>
                            <Currency value={parseFloat(current_value_spent)}/>*
                        </div>
                        }
                        {rewards_tier.key !== "no_tier" &&
                        <div className="rr-summary__segment-info">
                            <span className="icon-triangle-up rr-summary__segment-icon"/>
                            <span className="acc-rebag-rewards__text">
                                <Currency value={parseFloat(rewards_tier.tier_value)}/>
                            </span>
                            <strong className="acc-rebag-rewards__text">{rewards_tier.name}</strong>
                        </div>
                        }
                    </div>
                )
            })}
        </div>
    )
};

export default RebagRewardsProgressBar;